import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=51a6c4f0&scoped=true&"
import script from "./SortButton.vue?vue&type=script&lang=js&"
export * from "./SortButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6c4f0",
  null
  
)

export default component.exports